// extracted by mini-css-extract-plugin
export default {"combines__wrapper":"Combines_combines__wrapper__B+EMv","infiniteLoader":"Combines_infiniteLoader__p618K","spin":"Combines_spin__lAKsF"};